module.exports = {
  fallback: 'Selesaikan tantangan captcha.',
};
